import LegalLayout, { COMPANY, EMAIL } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Términos del Servicio">
      <p>Estos Términos rigen el uso de la plataforma Hephy 3D operada por {COMPANY}. Al registrarte o usar el servicio, aceptas estos Términos.</p>

      <h2>1. Descripción del servicio</h2>
      <p>Hephy 3D es una plataforma B2B que permite a comercios crear, personalizar y publicar productos 3D (joyería y prendas), integrarse con Wix y Shopify, y ofrecer un visor 3D interactivo a sus clientes.</p>

      <h2>2. Cuentas</h2>
      <p>Eres responsable de mantener la confidencialidad de tus credenciales y de toda la actividad en tu cuenta. Debes proporcionar información veraz y actualizada.</p>

      <h2>3. Suscripciones, comisiones y pagos</h2>
      <ul>
        <li>Los planes de suscripción se facturan de forma recurrente vía Stripe según el plan elegido.</li>
        <li>Podemos cobrar una comisión por transacción sobre las ventas realizadas con el personalizador, según la tarifa mostrada en tu panel (por defecto 1.5%), facturada de forma acumulada (semanal o mensual) a tu método de pago.</li>
        <li>Los servicios adicionales opcionales (p. ej., creación de versión 3D del producto, onboarding) pueden cobrarse como pago único.</li>
        <li>Autorizas los cargos correspondientes a tu método de pago registrado.</li>
      </ul>

      <h2>4. Prueba gratuita</h2>
      <p>Podemos ofrecer una prueba gratuita (p. ej., 7 días) que requiere registrar un método de pago. Si no cancelas antes de que termine, se aplicarán los cargos correspondientes.</p>

      <h2>5. Contenido del usuario</h2>
      <p>Conservas la titularidad del contenido que subes (imágenes, logos, modelos). Nos concedes una licencia limitada para alojarlo y procesarlo con el fin de prestar el servicio. Declaras que tienes los derechos necesarios sobre dicho contenido y que no infringe derechos de terceros.</p>

      <h2>6. Uso aceptable</h2>
      <ul>
        <li>No usar el servicio para actividades ilegales o infractoras.</li>
        <li>No intentar vulnerar la seguridad ni realizar ingeniería inversa.</li>
        <li>No subir contenido que infrinja marcas o derechos de autor de terceros sin autorización.</li>
      </ul>

      <h2>7. Integraciones de terceros</h2>
      <p>El uso de Wix, Shopify, Google y Stripe está sujeto a los términos de dichos proveedores. No somos responsables por cambios o interrupciones en sus servicios.</p>

      <h2>8. Cancelación</h2>
      <p>Puedes cancelar tu suscripción en cualquier momento; el acceso continúa hasta el fin del período pagado. Podemos suspender cuentas que incumplan estos Términos.</p>

      <h2>9. Garantías y responsabilidad</h2>
      <p>El servicio se ofrece "tal cual". En la máxima medida permitida por la ley, {COMPANY} no será responsable de daños indirectos o lucro cesante. Nuestra responsabilidad total se limita a los importes pagados en los 3 meses previos.</p>

      <h2>10. Ley aplicable</h2>
      <p>Estos Términos se rigen por las leyes de los Estados Unidos de América.</p>

      <h2>11. Contacto</h2>
      <p>{COMPANY} — <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>
    </LegalLayout>
  );
}
